// extracted by mini-css-extract-plugin
export default {"label":"Search_label__z67VC","input":"Search_input__cz+n7"};